import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { Modal } from 'react-bootstrap'
import { IInfoModal } from 'models/modals.model'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './InfoLessonModal.module.scss'
import Button from 'design-system/button'
import { ButtonSizes } from 'design-system/button/src/Button'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons'

interface IInfoLessonModal {
  data: IInfoModal
}

const InfoLessonModal: React.FC<IInfoLessonModal> = ({ data }) => {
  const {
    show,
    title,
    icon,
    iconType,
    message,
    buttonMessage,
    onContinue,
    onClose,
    showCancel,
  } = data
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    !show && setLoading(false)
  }, [show])

  const handleOnConinue = () => {
    setLoading(true)
    onContinue?.()
  }

  return (
    <Modal
      show={show}
      size={'lg'}
      centered
      className={styles.modalContainer}
      onHide={onClose}
    >
      <Modal.Header translate="yes" closeButton>
        {title}
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center">
          {icon && (
            <div
              className={classNames(
                styles.onCircle,
                iconType && styles[iconType]
              )}
            >
              <FontAwesomeIcon icon={icon} size={'3x'} />
            </div>
          )}
          <div className="ml-3">{message}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size={ButtonSizes.Small}
          onClick={handleOnConinue}
          disabled={loading}
        >
          {loading && (
            <FontAwesomeIcon icon={faSpinner} spin className={styles.spiner} />
          )}
          {buttonMessage}
        </Button>
        {showCancel && (
          <Button size={ButtonSizes.Small} onClick={onClose}></Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default InfoLessonModal
